export const fonts = [{
    label: "Uncial Antiqua",
    value: "Uncial Antiqua"
  }, {
    label: "Metal Mania",
    value: "Metal Mania"
  }, {
    label: "Atomic Age",
    value: "Atomic Age"
  }, {
    label: "Emblema One",
    value: "Emblema One"
  }, {
    label: "Miltonian",
    value: "Miltonian"
  }, {
    label: "Poppins",
    value: "Poppins"
  }, {
    label: "Staatliches",
    value: "Staatliches"
  }, {
    label: "Caveat",
    value: "Caveat"
  }, {
    label: "Satisfy",
    value: "Satisfy"
  }, {
    label: "Electrolize",
    value: "Electrolize"
  }, {
    label: "Luckiest Guy",
    value: "Luckiest Guy"
  }, {
    label: "Audiowide",
    value: "Audiowide"
  }, {
    label: "Pangolin",
    value: "Pangolin"
  }, {
    label: "Merienda One",
    value: "Merienda One"
  }, {
    label: "Capriola",
    value: "Capriola"
  }, {
    label: "Fredericka the Great",
    value: "Fredericka the Great"
  }, {
    label: "Aladin",
    value: "Aladin"
  }, {
    label: "Alegreya SC",
    value: "Alegreya SC"
  }, {
    label: "Ceviche One",
    value: "Ceviche One"
  }, {
    label: "Lemon",
    value: "Lemon"
  }, {
    label: "Abril Fatface",
    value: "Abril Fatface"
  }, {
    label: "Anton",
    value: "Anton"
  }, {
    label: "Dancing Script",
    value: "Dancing Script"
  }, {
    label: "Droid Sans",
    value: "Droid Sans"
  }, {
    label: "Droid Serif",
    value: "Droid Serif"
  }, {
    label: "Gloria Hallelujah",
    value: "Gloria Hallelujah"
  }, {
    label: "Indie Flower",
    value: "Indie Flower"
  }, {
    label: "Lato",
    value: "Lato"
  }, {
    label: "Lobster",
    value: "Lobster"
  }, {
    label: "Lora",
    value: "Lora"
  }, {
    label: "Montserrat",
    value: "Montserrat"
  }, {
    label: "Open Sans",
    value: "Open Sans"
  }, {
    label: "Oswald",
    value: "Oswald"
  }, {
    label: "PT Sans",
    value: "PT Sans"
  }, {
    label: "PT Serif",
    value: "PT Serif"
  }, {
    label: "Pacifico",
    value: "Pacifico"
  }, {
    label: "Playfair Display",
    value: "Playfair Display"
  }, {
    label: "Raleway",
    value: "Raleway"
  }, {
    label: "Roboto",
    value: "Roboto"
  }, {
    label: "Roboto Condensed",
    value: "Roboto Condensed"
  }, {
    label: "Roboto Slab",
    value: "Roboto Slab"
  }, {
    label: "Rubik",
    value: "Rubik"
  }, {
    label: "Slabo 27px",
    value: "Slabo 27px"
  }, {
    label: "Source Sans Pro",
    value: "Source Sans Pro"
  }, {
    label: "Ubuntu",
    value: "Ubuntu"
  }, {
    label: "Monoton",
    value: "Monoton"
  }, {
    label: "Bungee Inline",
    value: "Bungee Inline"
  }, {
    label: "Black Ops One",
    value: "Black Ops One"
  }, {
    label: "Finger Paint",
    value: "Finger Paint"
  }, {
    label: "Bungee Shade",
    value: "Bungee Shade"
  }, {
    label: "Ribeye Marrow",
    value: "Ribeye Marrow"
  }, {
    label: "Suez One",
    value: "Suez One"
  }, {
    label: "Teko",
    value: "Teko"
  }, {
    label: "Josefin Sans",
    value: "Josefin Sans"
  }, {
    label: "Acme",
    value: "Acme"
  }, {
    label: "Varela Round",
    value: "Varela Round"
  }, {
    label: "Archivo Black",
    value: "Archivo Black"
  }, {
    label: "Berkshire Swash",
    value: "Berkshire Swash"
  }, {
    label: "Righteous",
    value: "Righteous"
  }, {
    label: "Concert One",
    value: "Concert One"
  }, {
    label: "Fredoka One",
    value: "Fredoka One"
  }, {
    label: "Limelight",
    value: "Limelight"
  }, {
    label: "Cabin Sketch",
    value: "Cabin Sketch"
  }, {
    label: "Electrolize",
    value: "Electrolize"
  }, {
    label: "Niconne",
    value: "Niconne"
  }, {
    label: "Aclonica",
    value: "Aclonica"
  }, {
    label: "Reem Kufi",
    value: "Reem Kufi"
  }, {
    label: "Love Ya Like A Sister",
    value: "Love Ya Like A Sister"
  }, {
    label: "Vast Shadow",
    value: "Vast Shadow"
  }, {
    label: "Ravi Prakash",
    value: "Ravi Prakash"
  }, {
    label: "Germania One",
    value: "Germania One"
  }, {
    label: "Nosifer",
    value: "Nosifer"
  }, {
    label: "Pirata One",
    value: "Pirata One"
  }, {
    label: "Rubik Mono One",
    value: "Rubik Mono One"
  }, {
    label: "Butcherman",
    value: "Butcherman"
  }, {
    label: "Great Vibes",
    value: "Great Vibes"
  }, {
    label: "Teko",
    value: "Teko"
  }, {
    label: "Quicksand",
    value: "Quicksand"
  }, {
    label: "Bree Serif",
    value: "Bree Serif"
  }, {
    label: "Francois One",
    value: "Francois One"
  }, {
    label: "Kaushan Script",
    value: "Kaushan Script"
  }, {
    label: "Patua One",
    value: "Patua One"
  }, {
    label: "Permanent Marker",
    value: "Permanent Marker"
  }, {
    label: "Alfa Slab One",
    value: "Alfa Slab One"
  }, {
    label: "Cookie",
    value: "Cookie"
  }, {
    label: "Lalezar",
    value: "Lalezar"
  }, {
    label: "Patrick Hand",
    value: "Patrick Hand"
  }, {
    label: "Passion One",
    value: "Passion One"
  }, {
    label: "Boogaloo",
    value: "Boogaloo"
  }, {
    label: "Paytone One",
    value: "Paytone One"
  }, {
    label: "Playball",
    value: "Playball"
  }, {
    label: "Fugaz One",
    value: "Fugaz One"
  }, {
    label: "Oleo Script",
    value: "Oleo Script"
  }, {
    label: "Knewave",
    value: "Knewave"
  }, {
    label: "Bevan",
    value: "Bevan"
  }, {
    label: "Faster One",
    value: "Faster One"
  }, {
    label: "Leckerli One",
    value: "Leckerli One"
  }, {
    label: "Bungee",
    value: "Bungee"
  }, {
    label: "Pattaya",
    value: "Pattaya"
  }, {
    label: "Rye",
    value: "Rye"
  }, {
    label: "Federo",
    value: "Federo"
  }, {
    label: "Nova Square",
    value: "Nova Square"
  }, {
    label: "Ranchers",
    value: "Ranchers"
  }, {
    label: "New Rocker",
    value: "New Rocker"
  }]
  